import type { LineChartReportCardProps } from '../../AnalyticsDashboard.types'
import { useLineChartReportCard } from '../useLineChartReportCard'

const reportId = 'membership_active_members'

export const useMembershipsActiveMembersReportCard = (): LineChartReportCardProps => {
  return useLineChartReportCard({
    reportId,
    headerLabel: 'Active members',
    headerTooltipTitle: 'Active members',
    headerTooltipDescription: 'Number of members with an active paid subscription.',
  })
}
